/** Format numeric values, returning '-' if not a valid number. */
export function formatValue(value) {
  if (typeof value !== "number" || isNaN(value)) return "-";
  return value.toFixed(0);
}

/** Transform the roundHistory data into a suitable payload for your backend. */
export function transformRounds(data) {
  return {
    rounds: data.map((round) =>
      round.hits.map((hit) => ({
        label: hit.label.replace(/\s+/g, ""),
        score: hit.score,
        x: hit.x,
        y: hit.y,
      }))
    ),
  };
}
